<mat-expansion-panel
    class="mat-elevation-z0"
    [expanded]="pinnedPanels[silentDataKey]"
    #insuranceDetailsExpansionPanel
>
    <mat-expansion-panel-header>
        <mat-panel-title>
            <mat-icon class="cb-grey cb-margin-right">account_balance_wallet</mat-icon>
            <b>Insurance Details</b>
        </mat-panel-title>
        <mat-panel-description class="end-center flex-row">
            @if (insuranceDetailsExpansionPanel.expanded || silentData[silentDataKey]) {
                <button mat-icon-button (click)="togglePanelPinned($event, silentDataKey)">
                    <mat-icon svgIcon="pin" [ngClass]="{ 'cb-accent': silentData[silentDataKey] }">
                    </mat-icon>
                </button>
            }
        </mat-panel-description>
    </mat-expansion-panel-header>
    <div class="flex-col">
        <div class="flex-wrap flex">
            @if (insurancePriceField.isVisible) {
                <cb-display-value-new class="flex-50" label="Insured Price">
                    {{ lotMappedItem?.insurancePrice | cbDasher }}
                </cb-display-value-new>
            }
            @if (insuranceStartDateField.isVisible) {
                <cb-display-value-new class="flex-50" label="Insurance Start Date">
                    {{ lotMappedItem?.insurance.start | date: 'dd MMM yyyy' | cbDasher }}
                </cb-display-value-new>
            }
            @if (insuranceEndDateField.isVisible) {
                <cb-display-value-new class="flex-50" label="Insurance End Date">
                    {{ lotMappedItem?.insurance.end | date: 'dd MMM yyyy' | cbDasher }}
                </cb-display-value-new>
            }
            @if (insuranceInterestedPartyField.isVisible) {
                <cb-display-value-new class="flex-50" label="Interested Party">
                    {{ lotMappedItem?.insuranceInterestedParty | cbDasher }}
                </cb-display-value-new>
            }
            @if (insuranceInterestedPartyEmailField.isVisible) {
                <cb-display-value-new class="flex-50" label="Interested Party Email">
                    {{ lotMappedItem?.insuranceInterestedPartyEmail | cbDasher }}
                </cb-display-value-new>
            }
            @if (insuranceCoverNumberField.isVisible) {
                <cb-display-value-new class="flex-50" label="Cover Number">
                    {{ lotMappedItem?.insuranceCoverNumber | cbDasher }}
                </cb-display-value-new>
            }
        </div>
    </div>
</mat-expansion-panel>
